export enum ProjectPhases {
  PROJECT_APPROVAL = 'Project Approval',
  PROJECT_SETUP = 'Project Setup',
  DRAFTING = 'Drafting',
  PUBLIC_COMMENT = 'Public Comment',
  BALLOT = 'Ballot',
  PUBLICATION = 'Publication'
}



export enum MuleProjectPhases {
  PROJECT_APPROVAL = 'project approval',
  PROJECT_SETUP = 'project setup',
  DRAFTING = 'drafting',
  PUBLIC_COMMENT = 'public commenting',
  BALLOT = 'balloting',
  PUBLICATION = 'publication',
  COMBINED_PROCEDURE = 'combined procedure'
}
